import React from "react";
import {
  Swiper,
  SwiperSlide
} from 'swiper/react';

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import required modules
import {
  Pagination,
  Navigation
} from "swiper";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";

function GalleryPreview({ preview, edit }) {
  if (edit === true) {
    preview.img_urls = preview.gallery;
  }


  return (
    <>
      <CreativeNameDisplay preview={preview} />
      <div className="preview-inner">
        <div className="preview-gallery">
          <Swiper
            spaceBetween={50}
            pagination={true}
            navigation={true}
            modules={[Navigation, Pagination]}
            className="mySwiper h-full"
          >
            {edit === true
              ? preview.img_urls
                ? preview.img_urls.map((imgLink, index) => {
                  return <SwiperSlide > <img key={index} src={imgLink.image} alt="" className="w-full !h-[95%]" /> </SwiperSlide>;
                })
                : null
              : preview.img_urls.map((imgLink, index) => {
                return <SwiperSlide > <img key={index} src={imgLink} alt="" className="w-full !h-[95%]" /> </SwiperSlide>;
              })}
            <img src="https://d30365bzukh5e5.cloudfront.net/share_content_imgs/telugu_new3_v8.png" alt="way2news-logo" />

          </Swiper>
        </div>
      </div>
    </>
  );
}

export default GalleryPreview;
